module.exports = new __parcel__URL__("feature-1.c4f06806.png").toString();